import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'approval-na-icon',
  templateUrl: './approval-na-icon.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ApprovalNaIconComponent {}

